import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, cdpSettingsSource } from 'app.constants';
import { Contexts, } from 'modules/core/ContextProcessorService';
export class CDPController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'ContextProcessorService'];
    constructor(LoadingService, TranslateService, AccountService2, $state, ContextProcessorService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.$state = $state;
        this.ContextProcessorService = ContextProcessorService;
        this.settingsSource = cdpSettingsSource;
        this.checkTenantContext = async (ContextProcessorService) => {
            await ContextProcessorService.waitForInitialization();
            this.isOnTenantContext = this.ContextProcessorService.context === Contexts.Tenants;
        };
        this.checkTenantContext(ContextProcessorService);
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.LoadingService.stopLoading();
    }
}
CDPController.$inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'ContextProcessorService'];
